import { render, staticRenderFns } from "./Notificacion.vue?vue&type=template&id=c8e2e3fc&scoped=true&"
import script from "./Notificacion.vue?vue&type=script&lang=js&"
export * from "./Notificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e2e3fc",
  null
  
)

export default component.exports